/** Shared emoji sets for chat composer and chatbot reaction picker. */
export const EMOJI_CATEGORIES = [
    {
        id: "smileys",
        label: "😀",
        title: "Smileys",
        emojis: [
            "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃",
            "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "😚", "😙",
            "🥲", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫",
            "🤔", "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄", "😬",
            "😮‍💨", "🤥", "😌", "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕",
            "🤢", "🤮", "🤧", "🥵", "🥶", "🥴", "😵", "🤯", "🤠", "🥳",
            "🥸", "😎", "🤓", "🧐", "😕", "😟", "🙁", "☹️", "😮", "😯",
            "😲", "😳", "🥺", "😦", "😧", "😨", "😰", "😥", "😢", "😭",
            "😱", "😖", "😣", "😞", "😓", "😩", "😫", "🥱", "😤", "😡",
            "😠", "🤬", "😈", "👿", "💀", "☠️", "💩", "🤡", "👹", "👺",
        ],
    },
    {
        id: "gestures",
        label: "👋",
        title: "Gestures",
        emojis: [
            "👋", "🤚", "🖐️", "✋", "🖖", "👌", "🤌", "🤏", "✌️", "🤞",
            "🤟", "🤘", "🤙", "👈", "👉", "👆", "🖕", "👇", "☝️", "👍",
            "👎", "✊", "👊", "🤛", "🤜", "👏", "🙌", "👐", "🤲", "🤝",
            "🙏", "✍️", "💅", "🤳", "💪", "🦾", "🦿", "🦵", "🦶", "👂",
        ],
    },
    {
        id: "hearts",
        label: "❤️",
        title: "Hearts",
        emojis: [
            "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
            "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟", "♥️",
            "💋", "💌", "💐", "🌹", "🥀", "🌺", "🌸", "🌼", "🌻", "🌷",
        ],
    },
    {
        id: "animals",
        label: "🐶",
        title: "Animals",
        emojis: [
            "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐻‍❄️", "🐨",
            "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐔",
            "🐧", "🐦", "🐤", "🦄", "🐝", "🦋", "🐞", "🐢", "🐍", "🐙",
        ],
    },
    {
        id: "food",
        label: "🍕",
        title: "Food",
        emojis: [
            "🍎", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍒", "🍑",
            "🥭", "🍍", "🥥", "🥝", "🍅", "🥑", "🍆", "🥦", "🍔", "🍟",
            "🍕", "🌭", "🥪", "🌮", "🌯", "🍿", "🍩", "🍪", "🎂", "🍰",
            "☕", "🍵", "🧃", "🥤", "🧋", "🍺", "🍻", "🥂", "🍷", "🍸",
        ],
    },
    {
        id: "objects",
        label: "⚽",
        title: "Objects",
        emojis: [
            "⚽", "🏀", "🏈", "⚾", "🎾", "🏐", "🏉", "🎱", "🏓", "🏸",
            "🎮", "🕹️", "🎯", "🎲", "♟️", "🎵", "🎶", "🎤", "🎧", "🎸",
            "📱", "💻", "⌨️", "🖥️", "📷", "📸", "🎥", "📺", "💡", "🔦",
            "💰", "💳", "💎", "⚖️", "🛠️", "🔧", "🔨", "⚙️", "🧲", "🔫",
            "✈️", "🚀", "🚗", "🚕", "🚌", "🚓", "🚑", "🚒", "🛵", "🚲",
            "✅", "❌", "⭐", "🌟", "✨", "🔥", "💯", "🎉", "🎊", "🎈",
        ],
    },
];
